import { isDesktop } from 'react-device-detect';
import BonusGameController from '../../controllers/bonus/BonusGameController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { BonusGameGridView } from './BonusGameGridView';
import { BonusGameItems } from './BonusItems';

export const BonusGameView = {
	name: COMPONENTS.BONUS_GAME,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: BonusGameController,
			name: 'BonusGameController',
			config: {
				item: 'bonus_game_wrapper',
				val: 'bonus_game_wrapper'
			}
		},
		{
			Controller: MainGridController,
			name: 'BonusGameViewGrid',
			config: BonusGameGridView
		}
	],
	components: [
		{
			name: 'fg_holder',
			type: 'Sprite',
			components: [
				isDesktop
					? {
							name: 'bonus_fg',
							type: 'AnimatedSprite',
							position: {
								x: 0,
								y: 190
							},
							animation: {
								pattern: 'wpassive$.png',
								start: 0,
								end: 43,
								speed: 0.5,
								precision: 2,
								loop: true,
								scale: {
									x: isDesktop ? 1 : 2,
									y: isDesktop ? 1 : 2
								}
							}
						}
					: {
							name: 'bonus_fg',
							type: 'Sprite',
							position: {
								x: 0,
								y: 185
							},
							scale: {
								x: 1.3,
								y: 1.3
							},
							img: 'main_character_m'
						},
				isDesktop && {
					name: 'bonus_fg_wow',
					type: 'AnimatedSprite',
					position: {
						x: 25,
						y: 188
					},
					animation: {
						pattern: 'Active$.png',
						start: 0,
						end: 59,
						speed: 0.5,
						precision: 2,
						loop: false,
						scale: {
							x: isDesktop ? 1 : 1,
							y: isDesktop ? 1 : 1
						}
					}
				}
			]
		},
		{
			name: 'btn_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bonus_btn',
					type: 'StopButton',
					position: { x: 0, y: 0 },
					bg: 'spin_btn',
					animation: {
						pattern: 'stop$.png',
						start: 0,
						end: 25,
						speed: 0.5,
						loop: true
					}
				}
			]
		},
		{
			name: 'win_bg_wrapper',
			type: 'Sprite',
			components: [
				{
					name: 'win_bg',
					type: 'Sprite',
					img: 'bonus_total_win_bg',
					position: { x: 0, y: 0 }
				},
				{
					name: 'win_bg_border',
					type: 'Sprite',
					position: { x: -20, y: -23 },
					img: 'bonus_win_border'
				},
				{
					name: 'win_bg_border',
					type: 'Sprite',
					position: { x: -20, y: 97 },
					img: 'bonus_win_border',
					rotation: 3.14,
					anchor: { x: 1, y: 0 }
				},
				{
					name: 'win_text',
					type: 'Text',
					text: 'BONUS_WIN_TEXT',
					position: { x: 373 / 2 - 20, y: 0 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'win_value',
					type: 'Text',
					text: 'BONUS_WIN_VALUE',
					position: { x: 373 / 2 - 20, y: 28 },
					anchor: { x: 0.5, y: 0 }
				}
			]
		},
		{
			name: 'BonusItems',
			type: 'VisualComponent',
			component: BonusGameItems
		}
	]
};
